import { Role } from './user';

/**
 * The authRoles object defines the authorization roles for the Fuse application.
 */
const authRoles = {
	/**
	 * The admin role grants access to users with the 'admin' role.
	 */
	admin: [Role.Primary],

	/**
	 * The staff role grants access to users with the 'admin' or 'staff' role.
	 */
	staff: [Role.Primary],

	/**
	 * The user role grants access to users with the 'admin', 'staff', or 'user' role.
	 */
	user: [Role.Primary],

	/**
	 * The onlyGuest role grants access to unauthenticated users.
	 */
	onlyGuest: [],

};

export default authRoles;
